export const EnumOperacao = Object.freeze({

  FCL: 0,
  FCLDesovado: 1,
  LCL: 2,
  ExportacaoCnt: 3,
  Cabotagem: 4,
  ExportacaoCs: 5,
  CntVazio: 6,
  Portuaria: 7,
  PortuariaNaoConteiner: 8
})
